
    import './styles.scoped.css';
    export default {
  "options-list": "awsui_options-list_19gcf_1qfef_145",
  "options-list-embedded": "awsui_options-list-embedded_19gcf_1qfef_192",
  "decrease-block-margin": "awsui_decrease-block-margin_19gcf_1qfef_199"
};
  